<template>
    <div class="checkbox-container">
        <label class="checkbox" :class="classes">
            <input type="checkbox" @input="input" :checked="modelValue">
            <div class="checkmark">
                <img v-if="!disabled" src="@/assets/check-mark-white.svg"/>
                <img v-else src="@/assets/check-mark-dark.svg"/>
            </div>
            <span class="label">{{label}}</span>
        </label>
    </div>
</template>

<script>
    export default {
        name: "CheckBoxInput",
        emits: ['update:modelValue'],
        props: {
            modelValue: Boolean,
            label: { type: String, required: false },
            disabled: Boolean
        },
        computed: {
            classes(){
                return {
                    on: this.modelValue,
                    off: !this.modelValue,
                    disabled: this.disabled
                }
            }
        },
        methods: {
            input(e){
                this.$emit('update:modelValue', e.target.checked)
            }
        }
    }
</script>

<style scoped>
.checkbox {
  display: inline-flex;
  position: relative;
  padding-left: 44px;
  cursor: pointer;
  font-family: "Circular Std";
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  text-align: left;
  color: #435152;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #f7f9f9;
  transition: all 0.1s;
  border: 2px solid #435152;
}

.checkmark img {
  margin-top: 2px;
  margin-left: 2px;
  display: block;
  width: 24px;
  height: 24px;
  opacity: 0;
}

.checkbox:hover .checkmark {
  background-color: #ccc;
}
.checkbox.on:hover .checkmark {
  background-color: #566f71;
  border-color: #566f71;
}

.checkbox.on .checkmark img {
    opacity: 1;
}
.checkbox.on .checkmark {
  background-color: #435152;
}

.checkbox.disabled {
    pointer-events: none;
}
.checkbox.disabled .checkmark {
  background-color: transparent;
  border-color: rgba(0,0,0,0.05);
}

.checkbox.disabled .label {
    opacity: 0.5;
}

.checkbox.disabled.on .checkmark img {
    opacity: 0.15;
}

</style>
